var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabSettingsDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#36F6FF",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1248_26751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0417 24.75H10.4167C9.86439 24.75 9.41667 24.3023 9.41667 23.75V11.375C9.41667 10.8227 9.86439 10.375 10.4167 10.375H27.5833C28.1356 10.375 28.5833 10.8227 28.5833 11.375V12.2917M13.25 27.625H18.0417",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 17.125C21.875 16.5727 22.3227 16.125 22.875 16.125H28.5417C29.094 16.125 29.5417 16.5727 29.5417 17.125V26.625C29.5417 27.1773 29.094 27.625 28.5417 27.625H22.875C22.3227 27.625 21.875 27.1773 21.875 26.625V17.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7064 24.748H25.7104V24.752H25.7064V24.748Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1248_26751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabSettingsDeviceIcon);
export default __webpack_public_path__ + "static/media/tc_cab_settings_device_icon.4910ff8af0c918612e96207e29e1606b.svg";
export { ForwardRef as ReactComponent };